import { useState } from "react";

import Fail from "../assets/images/items/fail.png";
import Discount from "../assets/images/items/discount.png";
import Free from "../assets/images/items/free.png";

import topArrow from "../assets/icons/top-arrow.svg";
import bottomArrow from "../assets/icons/bottom-arrow.svg";

import Button from "./Button";

const Roulette = ({ setWinnerType, access, accessError, rouletteItemsList }) => {
  const [spinning, setSpinning] = useState(false);

  const getWinner = async () => {
    if (spinning) return;

    console.log("getWinner");

    const rouletteItemsHTML = document.querySelector(".roulette__items-inner");
    rouletteItemsHTML.style.transition = "transform 1s linear infinite";
    rouletteItemsHTML.style.transform = "translateX(-100%)";

    try {
      const response = await fetch("https://roulette.sp-hub.org/api/roulette/spin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${window.sessionStorage.getItem("jwtToken")}`,
        },
      });

      const data = await response.json();
      console.log("Winner data:", data);

      if (data) {
        spinRoulette(data);
      }
    } catch (error) {
      console.error("Error fetching winner:", error);
    }
  };

  const spinRoulette = (data) => {
    if (spinning) return;

    if (data.status === 403) {
      console.log(data.message);
      return;
    }

    setSpinning(true);

    console.log("Winner data:", data);

    const winnerType = data.type;
    const winnerIndex = 78;

    const rouletteItemsHTML = document.querySelector(".roulette__items-inner");
    const computedStyle = getComputedStyle(rouletteItemsHTML);
    const rouletteWheelHTML = document.querySelector(".roulette__wheel");
    const winnerElement = document.querySelectorAll(".roulette__item-img")[winnerIndex];

    if (winnerElement) {
      if (winnerType === "failed") {
        winnerElement.src = Fail;
        winnerElement.alt = "Завтра повезёт";
      } else if (winnerType === "discount") {
        winnerElement.src = Discount;
        winnerElement.alt = "Скидка 50% на отрисовку";
      } else if (winnerType === "free") {
        winnerElement.src = Free;
        winnerElement.alt = "Бесплатная отрисовка";
      }
    }

    const itemWidth = winnerElement.offsetWidth;
    const wheelContainer = rouletteWheelHTML.offsetWidth;
    const gap = parseInt(computedStyle.gap, 10);
    const position = winnerIndex * (itemWidth + gap);
    const centerOffset = wheelContainer / 2 - itemWidth / 2;
    const scrollDistance = position - centerOffset;

    rouletteItemsHTML.style.transition = "transform 4s ease-out";
    rouletteItemsHTML.style.transform = `translateX(-${scrollDistance}px)`;

    setTimeout(() => {
      setSpinning(false);
      setWinnerType(winnerType);
    }, 4000);
  };

  return (
    <>
      <div className="w-full mx-auto mobile:max-w-[285px] small:max-w-[324px] min-w-[240px] desktop:max-w-[994px]">
        <div className="relative roulette__wheel wheel mobile:h-[83px] desktop:h-[120px] flex bg-background rounded-sml h-[120px] justify-center content-center mobile:mb-8 desktop:mb-14">
          <div className="roulette__arrows absolute mobile:space-y-16 desktop:space-y-24 flex flex-col mobile:-mt-1 desktop:-mt-2 z-10">
            <img
              className="roulette__top-arrow-img mobile:h-[13px] mobile:w-[19px] desktop:h-[20px] desktop:w-[27px]"
              src={topArrow}
              alt="top-arrow"
            />
            <img
              className="roulette__bottom-arrow-img mobile:h-[13px] mobile:w-[19px] desktop:h-[20px] desktop:w-[27px]"
              src={bottomArrow}
              alt="bottom-arrow"
            />
          </div>
          <div className="roulette__items flex overflow-hidden rounded-[17px] flex-col justify-center h-full">
            <div className="roulette__items-inner">
              {rouletteItemsList.length > 0 ? (
                rouletteItemsList.map((item, key) => (
                  <img
                    key={key}
                    id={key}
                    src={item.img}
                    alt={item.alt}
                    className="roulette__item-img mobile:max-h-[60px] mobile:max-w-[60px] desktop:max-h-[92px] desktop:max-w-[92px]"
                  />
                ))
              ) : (
                <p>Loading...</p>
              )}
            </div>
          </div>
        </div>
      </div>
      {accessError && <p style={{ color: "#A6465F" }}>{accessError}</p>}
      <div className="flex justify-center mb-5">
        <Button onClick={getWinner} text="Крутить" disabled={!access || spinning} />
      </div>
    </>
  );
};

export default Roulette;
